import { FC } from 'react';
import { Box, Button, FormControl, Input, InputLabel, Paper, Stack } from '@mui/material';

import { FilterButton, FilterField } from './types';
import { ButtonContainer, ButtonsContainer } from './styled';

type FilterProps = {
  filterFields: FilterField[] | null;
  filterButtons?: FilterButton[] | null;
  maxFieldWidth?: string;
  fieldContainerWidth?: string;
};

export const Filter: FC<FilterProps> = (props) => {
  const { filterFields, filterButtons } = props;

  const fields = filterFields?.map((field) => {
    const { name, title, value, onChange, error, hidden, component, withoutLabel } = field;
    if (hidden) return;

    return (
      <Stack direction="column" key={name}>
        {component ? (
          <FormControl variant="standard">
            {!withoutLabel && <InputLabel>{title}</InputLabel>}
            {component}
          </FormControl>
        ) : (
          <FormControl>
            {!withoutLabel && <InputLabel>{title}</InputLabel>}
            <Input
              name={name}
              value={value ?? ''}
              onChange={onChange}
              className={error ? 'error' : undefined}
            />
          </FormControl>
        )}
      </Stack>
    );
  });

  const buttons = filterButtons?.length && (
    <ButtonsContainer>
      {filterButtons?.map((btn) => {
        const { name, text, onClick, disabled, btnProps } = btn;

        return (
          <ButtonContainer key={name}>
            <Button
              name={name}
              onClick={() => onClick()}
              disabled={disabled}
              {...btnProps}
              //
            >
              {text}
            </Button>
          </ButtonContainer>
        );
      })}
    </ButtonsContainer>
  );

  return (
    <Box>
      <Paper sx={{ p: 2, width: '100%' }}>
        <Stack direction="row" spacing={2} useFlexGap flexWrap="wrap">
          {fields}
          {buttons}
        </Stack>
      </Paper>
    </Box>
  );
};
